import { useState } from 'react';
import useFetch from '../../../hooks/useFetch';
import { buildEndpoint } from '../EndPoints';
import { ServiceEvents } from '../shared/interfaces';

const useContractTypeService = () => {
    const { doGet, doPost } = useFetch();
    
    const [fetchingAll, setFetchingAll] = useState(false);
    const [fetchingStore, setFetchingStore] = useState(false);
    const [fetchingEdit, setFetchingEdit] = useState(false);
    const [fetchingUpdate, setFetchingUpdate] = useState(false);
    const [fetchingActive, setFetchingActive] = useState(false);
    const [fetchingDelete, setFetchingDelete] = useState(false);
    
    const getAllContractTypes = (filters: any = {}, events: ServiceEvents = {}) => {
        const queryString = Object.entries(filters)
            .filter(([_, value]) => value !== undefined && value !== '')
            .map(([key, value]) => `${key}=${value}`)
            .join('&');
            
        doGet({
            ...events,
            url: buildEndpoint(`app/contract-drafting/admin/contract-types${queryString ? '?' + queryString : ''}`),
            setFetching: setFetchingAll
        });
    };
    
    const storeContractType = (data: any, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: buildEndpoint('app/contract-drafting/admin/contract-types/store'),
            body: data,
            setFetching: setFetchingStore
        });
    };
    
    const editContractType = (id: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: buildEndpoint(`app/contract-drafting/admin/contract-types/${id}/edit`),
            setFetching: setFetchingEdit
        });
    };
    
    const updateContractType = (id: number, data: any, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: buildEndpoint(`app/contract-drafting/admin/contract-types/${id}/update`),
            body: data,
            setFetching: setFetchingUpdate
        });
    };
    
    const activeContractType = (id: number, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: buildEndpoint(`app/contract-drafting/admin/contract-types/${id}/active`),
            setFetching: setFetchingActive
        });
    };
    
    const deleteContractType = (id: number, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: buildEndpoint(`app/contract-drafting/admin/contract-types/${id}/delete`),
            setFetching: setFetchingDelete
        });
    };
    
    return {
        fetchingAll,
        fetchingStore,
        fetchingEdit,
        fetchingUpdate,
        fetchingActive,
        fetchingDelete,
        getAllContractTypes,
        storeContractType,
        editContractType,
        updateContractType,
        activeContractType,
        deleteContractType
    };
};

export default useContractTypeService;

